/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsStaffOrdersCtrl
 */
angular.module('mercury.modules.reports.staff')
.controller('ReportsStaffDiscountsCtrl', ["$filter", "$q", "$scope", "reporttime", "ReportPosStaff", "PosDiscounts", "title", function($filter, $q, $scope, reporttime, ReportPosStaff, PosDiscounts, title) {
  title.set('Staff Discounts');

  $scope.discountTypeCols = [
    {label: 'Discount Type', type: 'string', key: 'discountType'},
    {label: 'Amount', type: 'number', key: 'discountsAmount', filter: 'currency'}
  ];

  $scope.loading = $q.all({
    staffDiscounts: ReportPosStaff.getDiscounts(reporttime.start(), reporttime.end()),
    discounts: PosDiscounts.get(reporttime.start(), reporttime.end())
  });

  $scope.loading.then(function(results) {
    $scope.discounts = results.discounts;
    $scope.staffDiscounts = results.staffDiscounts;
  });
}]);
